import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import React, { FC } from 'react';
import { AnalyticsKeys } from 'types/analytics';
import AnalyticsProvider from '../analytics/AnalyticsProvider';
import AnalyticsHeader from './AnalyticsHeader';
import Widget from './Widget';

const HomeAnalytics: FC = () => (
	<AnalyticsProvider>
		<>
			<Box display="flex">
				<AnalyticsHeader />
			</Box>
			<Grid container spacing={4} rowSpacing={3} pt={3}>
				<Grid container item xs={12} spacing={4}>
					<Grid item xs display="flex">
						<Widget analyticsKey={AnalyticsKeys.ActiveUsers} />
					</Grid>
					<Grid item xs display="flex">
						<Widget analyticsKey={AnalyticsKeys.NewUsers} />
					</Grid>
					<Grid item display="flex" xs={12} sm={6}>
						<Widget analyticsKey={AnalyticsKeys.deviceTypeGraph} />
					</Grid>
				</Grid>
				<Grid item display="flex" xs={12} sm={6}>
					<Widget analyticsKey={AnalyticsKeys.activeUsersGraph} />
				</Grid>
				<Grid item display="flex" xs={12} sm={6}>
					<Widget analyticsKey={AnalyticsKeys.newUsersGraph} />
				</Grid>
				<Grid item xs display="flex">
					<Widget analyticsKey={AnalyticsKeys.errors} />
				</Grid>
			</Grid>
		</>
	</AnalyticsProvider>
);

export default HomeAnalytics;
